/* eslint-disable css-modules/no-unused-class */
/* eslint-disable camelcase */
import React from 'react';
import style from '../style/lsrscorearc.scss';

const getArcStyle = (score, styles) => {
    switch (score) {
        case 'sufficient':
            return styles.lsr_score_arc_success;
        case 'insufficient':
            return styles.lsr_score_arc_failure;
        default:
            return styles.lsr_score_arc_unknown;
    }
};

const getConclusionText = (score, i18nParticipation) => {
    switch (score) {
        case 'sufficient':
            return i18nParticipation.report_lsr_conclusion_success;
        case 'insufficient':
            return i18nParticipation.report_lsr_conclusion_failure;
        default:
            return 'N/A';
    }
};

const LSRScoreArc = ({ i18nParticipation, score }) => {
    const arcStyle = getArcStyle(score, style);
    const conclusionText = getConclusionText(score, i18nParticipation);

    return (
        <div className={style.lsr_score_arc_wrapper}>
            <div className={style.lsr_score_arc}>
                <div className={`${style.lsr_score_arc_1} ${arcStyle}`} />
                <div className={`${style.lsr_score_arc_2} ${arcStyle}`} />
            </div>
            <p className={style.lsr_score_arc_text}>{conclusionText}</p>
        </div>
    );
};

export default LSRScoreArc;
